import { locale } from "../../translate";
import * as actionTypes from "../actionTypes";

export const setSystemSettings = (settings: actionTypes.settings) => ({
  type: actionTypes.SET_SYSTEM_SETTINGS,
  payload: settings
});

export const changeLocale = (locale: locale) => ({
  type: actionTypes.CHANGE_LOCALE,
  payload: locale
});
